import { useEffect } from 'react'

import ErrorLayout from '~/layouts/ErrorLayout'
import type { ExternalRedirectProps } from '~/types/component'

import PageLoading from './PageLoading'

const ExternalRedirect = ({ to }: ExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return (
    <ErrorLayout>
      <PageLoading>Mengarahkan ke laman Login...</PageLoading>
    </ErrorLayout>
  )
}

export default ExternalRedirect
